import React, { useContext, useMemo, useState } from 'react'
import { ReportingContext } from '../../../wrappers/ReportingContext'
import InformationalTextSection from './InformationalTextSection'

const CollapsibleContainer = ({
    title,
    editingComponent,
    displayComponent,
    children,
}) => {
    const { selectedFormSection } = useContext(ReportingContext)
    
    const isOpen = useMemo(() => {
        return selectedFormSection === title
    }, [selectedFormSection, title])

    const Component = isOpen ? editingComponent : displayComponent

    return (
        <div className={`container ${isOpen ? 'active' : 'hidden'}`}>
            <InformationalTextSection title={title} />
            {/* <div className="title">{title}</div> */}
            {/* <div className="box">{children}</div> */}
            {children}
        </div>
    )
}

export default CollapsibleContainer
